import { render, staticRenderFns } from "./ModalDeduplicateApplications.vue?vue&type=template&id=35ecf706"
import script from "./ModalDeduplicateApplications.vue?vue&type=script&lang=js"
export * from "./ModalDeduplicateApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports